import { api } from "@/lib/axios";

interface serviceCreationProps {
  serviceName: string;
  price?: number;
  serviceQuantity?: number;
  companyId: string;
  buildingsId?: string;
}

export async function createService({
  serviceName,
  price,
  serviceQuantity,
  companyId,
  buildingsId,
}: serviceCreationProps) {
  return await api.post(`/services/${companyId}`, {
    serviceName,
    price,
    serviceQuantity,
    ...(buildingsId && { buildingsId }),
  });
}
